// Import react elements.
import { useContext, useEffect, useState } from "react";

// Import API calls.
import { getFaqs } from "api/APIStrichCalls";

// Import context function.
import { AuthContext } from "global/context/AuthContext";

// Import hooks.
import usePageTitle from "global/hooks/usePageTitle";

// Import components.
import { LoadingSpinner } from "global/components/loading_ui/LoadingSpinnerAnimation";
import { FaqGrid } from "global/components/FaqGrid";

// Import css stylesheet.
import "./SupportPage.css";



const SupportPage = () => {

    // Set the page title.
    usePageTitle("Support");

    // Get the authenticated API token.
    const { token } = useContext(AuthContext);

    // Store the FAQ sections returned by the API.
    const [faqSections, setFaqSections] = useState([]);

    // Track the FAQ loading state.
    const [loading, setLoading] = useState(true);

    // Load the FAQs when authentication is available.
    useEffect(() => {

        // Stop until a token is available.
        if (!token) { return; }

        // Load all published FAQs.
        const loadFaqs = async () => {

            // Mark the FAQ content as loading.
            setLoading(true);

            // Request the FAQ sections.
            const response = await getFaqs(token);

            // Store the returned FAQ sections when the request succeeded.
            if (response?.success) {
                setFaqSections(Array.isArray(response.results) ? response.results : []);
            }

            // Mark the FAQ content as loaded.
            setLoading(false);

        };

        // Run the FAQ request.
        loadFaqs();

    }, [token]);



    // Render the support page.
    return (

        <div className="support-page">

            {/* Render the page heading. */}
            <div className="support-page__heading">
                <h1>Frequently Asked Questions</h1>
            </div>

            {/* Show a loading state while the FAQs are being requested. */}
            {loading ? (

                <div className="support-page__loading">
                    <LoadingSpinner message="Loading FAQs..." />
                </div>

            ) : (

                // Render all returned FAQ sections.
                <FaqGrid sections={faqSections} />

            )}

            {/* Keep direct support available below the FAQs. */}
            <p className="support-page__contact">
                Still need help? <a href="mailto:support@strichsuite.com">Contact us.</a>
            </p>

        </div>

    );

};

export default SupportPage;